var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.component,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          class: _vm.classes,
          attrs: {
            to: _vm.to || null,
            "active-class": !_vm.isExternal ? "-active" : null,
            "exact-active-class": !_vm.isExternal ? "-active" : null
          }
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon
        ? _c("c-icon", {
            staticClass: "icon",
            attrs: { icon: _vm.icon, width: _vm.iconSize, height: _vm.iconSize }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c02df29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c02df29","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CNavigationItem.vue
// module id = sPa4
// module chunks = 1624